module.exports = __webpack_public_path__ + "img/dg-browse-vehicles-default.48b29325.png";